import { gql } from '@apollo/client';

export const REFERRAL_PATIENT_MINI_DETAIL_FRAGMENT = gql`
  fragment ReferralPatientMiniDetailsFragment on PatientMiniDetail {
    full_name
    phone
  }
`;

export const REFERRAL_PATIENT_DETAIL_FRAGMENT = gql`
  fragment ReferralPatientDetailsFragment on PatientDetail {
    id
    firstname
    lastname
    full_name
    phone
    ssn
    mrn
    birthdate
    full_address
    insurance_provider
    policy_number
  }
`;